export default {
  meta: {
    title: '选址地图-分享页',
    url: '/sitemap', // 埋点字段，上报归属的模块
    urlName: '选址地图' // 埋点字段，上报归属的模块
  }
};

